import { call, put, select, takeLatest } from 'redux-saga/effects'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import { selectPageConfigurationData } from '@/store/PageConfiguration/PageConfigurationSelectors'
import getAPIConfig from '@/shared/tools/getAPIConfig'
import { initializeSaga } from '@/store/PageConfiguration/PageConfigurationSagas'
import { updateAssistanceFormErrors } from './AssistanceSlice'

export const assistanceActions = {
  UPDATE_ASSISTANCE: 'UPDATE_ASSISTANCE',
  CREATE_ASSISTANCE: 'CREATE_ASSISTANCE',
}

export function* updateAssistance({ assistanceData, id, initUrl, updateSuccessNotification }) {
  try {
    yield put(updateAssistanceFormErrors({}))
    const { authTokenSession, country } = yield select(selectAuthData)
    const { routes } = yield select(selectPageConfigurationData)
    const updateRoute = routes.update + '?lang=' + country + '&id=' + id

    const config = yield call(getAPIConfig, { method: 'put', authTokenSession, body: assistanceData })
    const response = yield call(fetch, updateRoute, config)
    const { errors } = yield call([response, response.json])

    if (response.status === 200) {
      yield call(updateSuccessNotification, 'AssistanceProducts bien mise à jour')
      yield call(initializeSaga, { initUrl: initUrl + '?lang=' + country })
    } else {
      yield put(updateAssistanceFormErrors(errors))
    }
  } catch (error) {
    console.error(error)
  }
}

export function* createAssistance({ assistanceData, initUrl, updateSuccessNotification }) {
  try {
    yield put(updateAssistanceFormErrors({}))
    const { authTokenSession, country } = yield select(selectAuthData)
    const { routes } = yield select(selectPageConfigurationData)

    const config = yield call(getAPIConfig, { method: 'post', authTokenSession, body: assistanceData })
    const response = yield call(fetch, routes.store + '?lang=' + country, config)
    const { errors } = yield call([response, response.json])

    if (response.status === 200) {
      yield call(updateSuccessNotification, 'AssistanceProducts crée')
      yield call(initializeSaga, { initUrl: initUrl + '?lang=' + country })
    } else {
      yield put(updateAssistanceFormErrors(errors))
    }
  } catch (error) {
    console.error(error)
  }
}

export default function* assistanceSagas() {
  yield takeLatest(assistanceActions.UPDATE_ASSISTANCE, updateAssistance)
  yield takeLatest(assistanceActions.CREATE_ASSISTANCE, createAssistance)
}
